import { Pipe, PipeTransform } from '@angular/core';
import { toBrDateString } from '../../core/utils/date.util';

@Pipe({
  name: 'brDate',
  standalone: true
})
export class BrDatePipe implements PipeTransform {
  transform(value: Date | string | null | undefined): string {
    return toBrDateString(value) ?? '-';
  }
}
